module.exports = __webpack_public_path__ + "static/media/03.81f8b4ca.webp";